<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' 
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :rowSelected='rowSelecting'>
      <e-columns :columns='shipColumns' textAlign='Center' clipMode='EllipsisWithTooltip'>
        <e-column type="checkbox" width="20" textAlign="center"></e-column>
        <e-column field='id' minWidth='10' :headerText='$t("DeployManagement.nodeID")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>  
        <e-column field='name' minWidth='10' :headerText='$t("DeployManagement.nodeName")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='ip' minWidth='10' :isPrimaryKey='true' :headerText='$t("DeployManagement.nodeIP")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
         <e-column field='displaySoftwareVersion' minWidth='10' :headerText='$t("DeployManagement.displaySoftWareVersion")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
       <!-- <e-column field='typeCode' minWidth='10' :headerText='$t("DeployManagement.nodeType")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>-->
       <!-- <e-column field='softwareVersion' minWidth='10' :headerText='$t("DeployManagement.productVersion")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>-->       
        <!-- <e-column field='createTime' minWidth='10' :headerText='$t("DeployManagement.createTime")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip' :formatter='actDate'></e-column> -->
        <!--<e-column field='errorStr' minWidth='10' :headerText='$t("Track.result")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='resultFormat'></e-column>-->
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getTrackListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager> 
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import socketInstance from '../../../plugins/stompSock';

  const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
  export default {
    name: 'configExTable',
    components: {
    },
    props: ['trackType'],
    data() {
      return {
        selectionOptions: { type: 'Single' },
        contextMenuItems: [
          { text: `${this.$t('Track.activationTask')}` },
          { text: `${this.$t('Track.suspendTask')}` },
          { text: `${this.$t('Track.taskDeletion')}` },
          { text: `${this.$t('Track.taskTracking')}` },
          { text: `${this.$t('Track.taskDetails')}` }
        ],
        trackStatus: { // 配置不同状态对应的值
          issued: 0,
          greate: 1,
          tracing: 2,
          hangup: 3,
          delete: 4,
          finish: 5
        },
        queryConditions: {
          keywords: '' // 任务名称模糊查询关键字
        },
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        page: {
          pageNo: 1,
          pageSize: 15,
          totalCount: 0,
          pageCount: 10
        },
        currentSelectDataId: '',
        addDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'add',
            title: this.$t('Track.createTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveAddTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        updateDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'update',
            title: this.$t('Track.updateTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveUpdateTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'detail',
            title: this.$t('Track.signalingDetails'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.close'), isPrimary: true } }
            ]
          }
        },
        websocketSetting: [
          { topic: '/topic/#/TrackTaskServer', clientId: 'track', callback: this.websocketCallback }
        ],
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      ...mapActions(['setCurrentNe']),
      statusFormat(grids, data) {
        const { taskStatus } = data;
        switch (taskStatus) {
          case this.trackStatus.issued:
            return `<span style='color:blue;'>${this.$t('Track.issued')}</span>`;
          case this.trackStatus.greate:
            return `<span style='color:blue;'>${this.$t('Track.greate')}</span>`;
          case this.trackStatus.tracing:
            return `<span style='color:green;'>${this.$t('Track.tracing')}</span>`;
          case this.trackStatus.hangup:
            return `<span style='color:red;'>${this.$t('Track.hangup')}</span>`;
          case this.trackStatus.delete:
            return `<span>${this.$t('Track.delete')}</span>`;
          case this.trackStatus.finish:
            return `<span style='color:orange;'>${this.$t('Track.finish')}</span>`;
          default:
            return taskStatus;
        }
      },
      resultFormat(grids, data) {
        if (data.errorCode === 0) {
          return this.$t('Track.success');
        } else if (data.errorCode === 1) {
          return this.$t('Track.autoActivationFailed');
        }
        //去掉保存功能
        // else if (data.errorCode === 2) {
        //   return `<button eventLS='reSure' class='e-control e-btn e-lib e-primary'>${this.$t('Track.reIssued')}</button>`;
        // }
        return this.$t('Track.error');
      },
      rowSelecting(args){
        const selectedRecords = this.$refs.grid.getSelectedRecords();
      },
      getChoose(args) {
       const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (args.target.innerHTML === this.$t('Track.reIssued') && args.isInteracted === true) {
          if (args.name === 'rowDeselected' && args.data.length > 0) {
            if (args.data[0].taskId === this.currentSelectDataId) {
              this.reSaveFunc(args.data[0]);
            }
          }
        }
      },

      formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
      actDate(grids, data) {
      if(!!data.createTime&&data.createTime!=null){
        return this.formatDateTime(data.createTime);
      }else{
        return '';
      }
    },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
          return;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList.forEach(elem => {
          elem.style.display = 'block';
        });
        switch (this.getCheckedVals().taskStatus) {
          case this.trackStatus.greate: break;
          case this.trackStatus.tracing: // 正在执行时不显示激活选项
            childList[0].style.display = 'none';
            break;
          case this.trackStatus.hangup: // 挂起时不显示挂起选项
            childList[1].style.display = 'none';
            break;
          case this.trackStatus.delete: break;
          case this.trackStatus.finish: break;
          default:
        }
      },
      dialogHide() {
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        this.$refs.updateDialog.clear();
        this.$refs.updateDialog.close();
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();     
        return selectedRecords;
      },
      getCheckedVals() {
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          return checkedData[0];
        }
        return false;
      },
      getTrackListData() {
         const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        const params = {
          displaySoftwareVersion: This.queryConditions.keywords ? This.queryConditions.keywords : '',
          pageNo: parseInt(This.page.pageNo, 10),
          pageSize: parseInt(This.page.pageSize, 10)
        };
        // 获取表格数据
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
          This.$axios.post('/lte/ems/config/mml/queryAllNePage',params).then((response) => {
            if (response && response.status === 200) {
              const result = response.data.resultVal;
              This.page.totalCount = result.totalCount;
              // This.page.pageCount = result.totalPages;
              This.data = result.result;
              // This.primaryDatas = This.data;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
      }
    },
    mounted() {
       this.getTrackListData();
      // bus.$on('loadTrackTable', (neNode) => {
      //   this.currentNeInfo = neNode;
      //   this.queryConditions.keywords = '';
      //   this.page.pageNo = "1";
      //   this.$refs.pager.ej2Instances.currentPage = 1;
      //   this.getTrackListData();
      //   this.setCurrentNe(neNode);
      //   bus.$emit('curMoData');
      // });
      bus.$on('refreshTrackTable', () => {
        this.getTrackListData();
      });
      // this.getTrackListData();
      setTimeout(this.websocketCallback, 5000);
    },
    beforeDestroy() {
      // bus.$off('loadTrackTable');
      bus.$off('refreshTrackTable');
    }
  };
</script>
